// extracted by mini-css-extract-plugin
module.exports = {"funkcjeContainer":"funkcje-crm-module--funkcjeContainer--2i47t"};